import {
  UserToken as UserTokenDomainModeType,
  IUser as IUserDomainModelType
} from '../models/user';
export type UserToken = UserTokenDomainModeType;

export type IUser = IUserDomainModelType;

export const author1: IUser = {
  id: 'e46cc712-481f-4d56-abad-c4c602b4c87f',
  firstName: 'A.Matthew',
  lastName: 'Lewis',
  email: 'lewis.berghahn.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: '0000-0002-0384-6285',
  realm: 'berghahn',
  status: 'active'
};

const author1PreProd: IUser = {
  ...author1,
  id: '8fc6a9d1-212b-449a-9b86-5f94688d2456'
};

const editor1: IUser = {
  id: 'ee50a937-1a03-4a22-8cdb-28a68d3baed3',
  firstName: 'A.Aiden',
  lastName: 'Cruz',
  email: 'aiden.berghahn.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: '0000-0002-0384-6285',
  realm: 'berghahn',
  status: 'active'
};

const editor1PreProd: IUser = {
  ...editor1,
  id: 'bba8d6a2-8917-4d9b-a335-506f291fe1ae'
};

const editor2: IUser = {
  id: '07639c8b-66ec-4796-9ef1-078aa1157129',
  firstName: 'C.Charlotte',
  lastName: 'Davis',
  email: 'charlotte.berghahn.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: '0000-0002-0384-6285',
  realm: 'berghahn',
  status: 'active'
};
const editor2PreProd: IUser = {
  ...editor2,
  id: '2c746449-038a-4125-a71a-6b1c1d33d1b2'
};

const editor3: IUser = {
  id: '5142666e-265a-4e69-b5bb-b3c86b2f773d',
  firstName: 'S.Simon',
  lastName: 'Clarke',
  email: 'simon.berghahn.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: '0000-0002-0384-6285',
  realm: 'berghahn',
  status: 'active'
};
const editor3PreProd: IUser = {
  ...editor3,
  id: 'ee65ea73-2535-4f49-aeb8-13b0a6038de8'
};

const reviewer1: IUser = {
  id: '2fc61b38-cdbf-49cb-aef3-aa2934e898f7',
  firstName: 'R.John',
  lastName: 'Doe',
  email: 'doe.berghahn.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: '0000-0002-0384-6285',
  realm: 'berghahn',
  status: 'active'
};

const reviewer1PreProd: IUser = {
  ...reviewer1,
  id: '7beb8fd4-7da0-4fc4-9d6b-9676b9ac5864'
};

const reviewer2: IUser = {
  id: '13fb0891-9a5f-48c3-a1dd-d1fe99dca5ac',
  firstName: 'R.Monalisa',
  lastName: 'Paine',
  email: 'paine.berghahn.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: '0000-0002-0384-6285',
  realm: 'berghahn',
  status: 'active'
};

const reviewer2PreProd: IUser = {
  ...reviewer2,
  id: 'b906f751-308f-4b3a-b0b8-e30a35194dea'
};

const orgAdmin1: IUser = {
  id: '5c8bc350-2756-4eaa-ae47-f2b515d0d1ac',
  firstName: 'O.Oscar',
  lastName: 'Odin',
  email: 'odin.berghahn.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: '0000-0002-0384-6285',
  realm: 'berghahn',
  status: 'active'
};

const orgAdmin1PreProd: IUser = {
  ...orgAdmin1,
  id: '2ad524dc-2127-4237-866b-86d508f37b4b'
};
const orgAdmin1Prod: IUser = {
  ...orgAdmin1,
  id: '743e68cb-cf41-451c-af8f-cb638496b14b'
};

const sysAdmin1: IUser = {
  id: '0162df11-4dbf-41a2-a78b-42553b59615a',
  firstName: 'Sudo',
  lastName: 'User',
  email: 'sudo.berghahn.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: '0000-0002-0384-6285',
  realm: 'berghahn',
  status: 'active'
};

const sysAdmin1PreProd: IUser = {
  ...sysAdmin1,
  id: 'a5b75234-177c-4ca8-9587-a09e65b0d91f'
};

const sysAdmin1Prod: IUser = {
  ...sysAdmin1,
  id: '7f48e3b2-2634-4272-9b54-d527567ba71e'
};

export const STAGING_USERS_MAP = {
  author1,
  editor1,
  editor2,
  editor3,
  reviewer1,
  reviewer2,
  orgAdmin1,
  sysAdmin1
} as const;

export const PREPROD_USERS_MAP = {
  author1: author1PreProd,
  editor1: editor1PreProd,
  editor2: editor2PreProd,
  editor3: editor3PreProd,
  reviewer1: reviewer1PreProd,
  reviewer2: reviewer2PreProd,
  orgAdmin1: orgAdmin1PreProd,
  sysAdmin1: sysAdmin1PreProd
} as const;

export const PROD_USERS_MAP = {
  orgAdmin1: orgAdmin1Prod,
  sysAdmin1: sysAdmin1Prod
} as const;
